<template>
  <mt-header fixed :title="title" class="app-header" :style="headerHeight">
    <template v-if="showBack">
      <mt-button icon="back" slot="left" @click="goback">{{backText}}</mt-button>
    </template>
    <template v-if="showCreate">
      <mt-button slot="right" v-on:click="create" class="add-btn">
        <span class="icon-plus"></span>
      </mt-button>
    </template>
  </mt-header>
</template>

<script>
  import Tools from '../../utils/Tools'
export default {
  name: 'my-header',
  template: '#my-header',
  props: ['title', 'showBack', 'backText','showCreate'],
  data () {
    return {
      headerHeight: {}
    }
  },
  beforeMount(){
    const {headerHeight = -1} = Tools.getRequestParam();
    if (headerHeight > 0) {
      this.headerHeight = {height: headerHeight + 'px !important'}
    }
  },
  methods: {
    goback () {
      // console.log('window.history', window.history);
      // console.log('this.$router', this.$router);
      // if (window.history.length <= 1) {
      //   if(!!this.global.isMiniProgrm){
      //     wx.miniProgram.navigateBack({
      //       delta: 1
      //     });
      //     return;
      //   }
      // }
      this.$router.go(-1);
    },
    create(){
      this.$emit('create');
    }
  }
}
</script>
<style>
.app-header{
  height: 1rem !important;
  background: #feac00 !important;
  font-size: 0.36rem !important;
}
.add-btn{
  font-size: 0.36rem !important;
}
</style>
